import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getSpaSubCategories = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaSubCategory/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching spa sub categories:", error);
    throw error;
  }
};

export const saveSpaSubCategory = async (subCategory, modifiedByUserId) => {
  const response = await axios.post(`${BASE_URL}/api/SpaSubCategory/save?modifiedByUserId=${modifiedByUserId}`, subCategory, {
    headers: getAuthHeader(),
  });
  return response.data;
};

// API to export spa sub categories to Excel
export const exportSpaSubCategoriesToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaSubCategory/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SpaSubCategoryReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting spa sub categories:", error);
    throw error;
  }
};
